import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Ruben from '../AllImages/Rubenn.png';
import Jesus from '../AllImages/Jesus.jpeg';

const Support = () => {
  // Updated FAQ data with refined, kind, and professional answers
  const faqs = [
    {
      question: "Where will rehearsals take place, and how can I access them?",
      answer:
        "The rehearsal location will be detailed in your itinerary. If the information is not yet available, please note that we are in the final stages of selecting the venue and will update you as soon as the details are confirmed.",
    },
    {
      question: "Are there any additional fees for instrument rental or shipping?",
      answer:
        "There are no additional fees. Simanof will manage the rental of instruments such as cellos, bass, and percussion at no extra cost to you.",
    },
    {
      question: "Is there a dress code for the performance?",
      answer:
        "Yes, we kindly request that all participants adhere to a 'Concert Black' dress code to ensure an elegant and unified appearance during the performance.",
    },
    {
      question: "Can friends and family purchase tickets to the performance?",
      answer:
        "Our concerts are open to the public and free of charge. We warmly welcome friends and family to join us for this special event.",
    },
    {
      question: "Is accommodation included or recommended?",
      answer:
        "Accommodation, along with transportation, dining, and attractions, is included in the tour package. We have arranged these details to ensure your complete comfort and convenience throughout the tour.",
    },
    {
      question: "What is the refund policy if I need to cancel?",
      answer:
        "We regret to inform you that, due to our commitment to advance bookings for attractions, hotels, and restaurants, we are unable to offer refunds once payment is received. We appreciate your understanding in this matter.",
    },
    {
      question: "Will there be any optional tours or sightseeing opportunities?",
      answer:
        "Optional tours and sightseeing opportunities are available. If you are over the age of 18 or accompanied by an adult, please speak with our staff for further details, and we will be delighted to assist you.",
    },
    {
      question: "How do I handle special requests or accessibility needs?",
      answer:
        "For any special requests or accessibility needs, please do not hesitate to reach out to our staff at Information@simanof.org or call 773-710-9953. We are dedicated to ensuring a comfortable and inclusive experience for all.",
    },
  ];

  // Track which FAQ is expanded
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="bg-gray-800 min-h-screen py-12 text-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Title */}
        <h1 className="text-3xl sm:text-4xl font-extrabold mb-6 text-center text-yellow-400">
          Support & FAQs
        </h1>
        <p className="text-center text-gray-300 mb-12">
          We’re here to help you have the best orchestral tour experience in New York.
          Below are some common questions and our contact information if you need further assistance.
        </p>

        <div className="flex flex-col md:flex-row gap-8">
          {/* Left Side: Contact Info for Ruben and Jesus */}
          <div className="w-full md:w-1/3 flex flex-col gap-8">
            {/* Ruben Siman Card */}
            <div className="bg-gray-900 shadow-lg rounded-lg p-6 flex flex-col items-center">
              <img
                src={Ruben}
                alt="Ruben Siman"
                className="object-cover w-36 h-36 rounded-full shadow-md mb-4"
              />
              <h2 className="text-xl font-semibold text-yellow-400">Ruben Siman</h2>
              <p className="text-gray-300">Executive Director</p>
              <p className="text-gray-300 mt-2">Phone: +1 (773) 710-9953</p>
              <p className="text-gray-300">Email: Information@simanof.org</p>
            </div>

            {/* Jesus Azucar Card */}
            <div className="bg-gray-900 shadow-lg rounded-lg p-6 flex flex-col items-center">
              <img
                src={Jesus}
                alt="Jesus Azucar"
                className="object-cover w-36 h-36 rounded-full shadow-md mb-4"
              />
              <h2 className="text-xl font-semibold text-yellow-400">Jesus Azucar</h2>
              <p className="text-gray-300">Assisting Tour Coordinator</p>
              <p className="text-gray-300 mt-2">Phone: +1 (689) 242-2621</p>
              <p className="text-gray-300">Email: Production@simanof.org</p>
            </div>
          </div>

          {/* Right Side: FAQ Section */}
          <div className="w-full md:w-2/3">
            <h2 className="text-2xl font-bold mb-4 text-yellow-400">
              Frequently Asked Questions
            </h2>
            <div className="space-y-2">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-gray-900 shadow rounded-lg mb-2">
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full text-left py-4 px-4 focus:outline-none flex items-center justify-between"
                  >
                    <span className="text-gray-100 font-medium">
                      {faq.question}
                    </span>
                    <motion.svg
                      className="w-5 h-5 text-gray-300"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      initial={false}
                      animate={{ rotate: expandedIndex === index ? 180 : 0 }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </motion.svg>
                  </button>

                  <AnimatePresence>
                    {expandedIndex === index && (
                      <motion.div
                        key="content"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        className="overflow-hidden text-gray-300 px-4 pb-4"
                      >
                        <p>{faq.answer}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
